export default class  ForgotPasswordDto {
    email!: string;
    type!: number;
    returnCode!: number;
    userID!: number;
    newPassword!: string;
  }
  